import * as React from 'react';
import { Checkbox, UIText1, UIText2 } from '@cian/ui-kit';
import * as styles from './PublicationFromPackageCheckboxMobile.css';

export interface IPublicationFromPackageCheckboxMobileProps {
  label: string;
  checked: boolean;
  disabled: boolean;

  handleChange(): void;
}

export const PublicationFromPackageCheckboxMobile = ({
  label,
  checked,
  disabled,
  handleChange,
}: IPublicationFromPackageCheckboxMobileProps) => {
  return (
    <label className={styles.wrapper}>
      <Checkbox
        checked={checked}
        disabled={disabled}
        onChange={handleChange}
        data-testid="PublicationFromPackageCheckbox"
      />

      <div className={styles.label} onClick={handleChange}>
        <UIText1 display="block">Из пакета</UIText1>

        {Boolean(label) && (
          <UIText2 color="gray60_100" display="inline-block">
            {label}
          </UIText2>
        )}
      </div>
    </label>
  );
};
